<template>
  <div class="num-setted">
    <div class="tc mt-5 mb-5">
      <h3>已设定号码</h3>
    </div>
    <div class="tc">
      <span class="mr-1">站别类型</span>
      <Select v-model="nowSite" style="width: 110px;">
        <Option v-for="item in siteAllList" :value="item.id" :key="item.id">{{ item.value }}</Option>
      </Select>
      <span class="ml-4 mr-1">彩种系列</span>
      <Select v-model="nowSeries" style="width: 120px;">
        <Option v-for="item in gameSeries" :value="item.id" :key="item.id">{{ item.value }}</Option>
      </Select>
      <span class="ml-4 mr-1">彩种</span>
      <Select v-model="nowGame" style="width: 130px;">
        <Option
          v-for="item in filterGame"
          :value="item.gameid"
          :key="item.gameid"
        >{{ item.gamename }}</Option>
      </Select>
      <span class="ml-4 mr-1">開獎狀態</span>
      <Select v-model="openLotteryState" style="width: 70px;">
        <Option :value="0">全部</Option>
        <Option :value="1">已开奖</Option>
        <Option :value="2">未开奖</Option>
      </Select>
      <span class="ml-4 mr-1">赛事开奖时间</span>
      <DatePicker
        type="daterange"
        placeholder="开始时间 - 结束时间"
        v-model="searchDate"
        :clearable="false"
        style="width: 200px"
      />
      <Button
        class="mx-1 dateBtn"
        v-for="it in dateBtns"
        :key="it.id"
        @click="setDate(it.id)"
      >{{ it.name }}</Button>
      <Button class="mx-1" type="primary" @click="search">
        <Icon type="ios-search" />查询
      </Button>
      <slot name="recordBtn"></slot>
    </div>
    <lidaTable :propscolumns="columns" :data="apiData" :propsPageSize="20" :isSearch="false" />
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import moment from "moment-timezone";
import numAndAct from '../mixins/numAndAct'
export default {
  name: 'NumSettedTable',
  mixins: [numAndAct],
  props: {
    recordBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      columns: {
        gameid: {
          title: '彩种名称',
          key: 'gameid',
          align: 'center',
          render: (h, params) => {
            let gamename = this.getAllGame.find(it => it.gameid == params.row.gameid).gamename
            return h('span', gamename)
          },
        },
        period: {
          title: '期数',
          key: 'period',
          align: 'center'
        },
        endate: {
          title: '赛事开奖时间',
          key: 'endate',
          align: 'center'
        },
        mark: {
          title: '已指定号码',
          key: 'mark',
          align: 'center'
        },
        opdate: {
          title: '状态',
          align: 'center',
          render: (h, params) => {
            let now = moment(moment.tz('Asia/Hong_Kong')).valueOf()
            let endate = moment(moment(params.row.endate)).valueOf()
            return h('span', {
              class: endate - now < 0 ? 'green-text' : 'red-text'
            }, endate - now < 0 ? '已开奖' : '未开奖')
          }
        }
      },
      openLotteryState: 0
    }
  },
  computed: {
    ...mapGetters(["getmember"]),
    apiQuery () {
      let endate = moment(this.searchDate[1]).add(1, 'days').format('YYYY-MM-DD')
      let stdate = moment(this.searchDate[0]).format('YYYY-MM-DD')
      let queryData = {
        stdate: stdate,
        endate: endate,
        gamelist: this.nowGame || (this.filterGame.filter(it => it.gameid != 0).map(it => it.gameid)).toString()
      }
      return queryData
    }
  },
  watch: {
    openLotteryState: 'search'
  },
  created () {
    this.search()
  },
  methods: {
    async search () {
      try {
        let res = await this.$axios.gameLobby.GamePeriodMarkAll(this.apiQuery)
        if ('status' in res && res.status === 0) return
        res.sort((a, b) => {
          let v1 = a.gameid
          let v2 = b.gameid
          if (v1 == v2) {
            return a.period - b.period
          }
          return v2 - v1
        })

        this.apiData = res.filter(this.filterOpenLottery)
      } catch (error) {
        console.error(error)
      }
    },
    filterOpenLottery (it, index) {
      if (this.openLotteryState === 0) return true
      let now = moment(moment.tz('Asia/Hong_Kong')).valueOf()
      let endate = moment(moment(it.endate)).valueOf()
      if (this.openLotteryState === 1) {
        return endate - now < 0
      } else {
        return endate - now > 0
      }
    }
  }
}
</script>

<style lang="scss">
.dateBtn {
  color: #fff;
  background-color: #909090;
  border-color: #909090;
  &:hover {
    color: #fff;
    background-color: #bdbdbd;
    border-color: #bdbdbd;
  }
}
</style>